import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useResource, useInvalidator } from 'rest-hooks';
import { ReplyChain, CommentReply, H6, H5 } from '@contently/toolkit';
import CommentResource from '../../resources/CommentResource';
import { updateCommentListCacheBust } from '../../store/textEditorReducer';

function DefaultReplyView({ numReplies, reply }) {
  if (!reply) return null;

  return (
    <React.Fragment>
      <div>
        <H6>{numReplies} Replies</H6>
        <H5>most recent reply</H5>
      </div>
      <CommentReply {...reply} />
    </React.Fragment>
  );
}

const replyTypes = {
  body: PropTypes.string,
  avatar: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  formattedCreatedAt: PropTypes.string.isRequired,
  authorIsEmployee: PropTypes.bool,
  authorIsManagingEditor: PropTypes.bool
};

DefaultReplyView.propTypes = {
  numReplies: PropTypes.number.isRequired,
  reply: PropTypes.shape(replyTypes).isRequired
};

export default function ReplyChainContainer({ commentId, showAllComments, sidebar }) {
  const dispatch = useDispatch();
  const invalidateCommentListCache = useInvalidator(CommentResource.listShape());
  const { commentListCacheBust } = useSelector(state => state.textEditor);
  const replies = useResource(CommentResource.listShape(), {
    parent_id: commentId
  });

  const withAvatars = replies.map(reply => {
    const { fullName, avatar } = reply.authorable;
    return { ...reply, fullName, avatar };
  });

  const lastReply = replies.length ? withAvatars[replies.length - 1] : null;

  useEffect(() => {
    if (commentListCacheBust && commentListCacheBust === commentId && sidebar) {
      invalidateCommentListCache({ parent_id: commentId });
      dispatch(updateCommentListCacheBust(null));
    }
  }, [commentId, commentListCacheBust, dispatch, invalidateCommentListCache, sidebar]);

  return showAllComments ? (
    <ReplyChain replies={withAvatars} />
  ) : (
    lastReply && <DefaultReplyView reply={lastReply} numReplies={replies.length} />
  );
}

ReplyChainContainer.defaultProps = {
  sidebar: false
};

ReplyChainContainer.propTypes = {
  commentId: PropTypes.string.isRequired,
  showAllComments: PropTypes.bool.isRequired,
  sidebar: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/ReplyChainContainer.jsx